require('./bootstrap');
require('./external-blank');
require('./menu');
// require('./lios-trigger'); // For hidden images (eg in menu/slider/accordion)
require('./header-size');
require('./ccfs');
require('./tag-filtering');
require('./cookiebar');
// require('./svg-sprite');


// var SpellChecker = require('simple-spellchecker/index');


// SpellChecker.getDictionary("en-GB", function(err, dictionary) {
//     if(!err) {
//         var misspelled = !dictionary.spellCheck('colourr');
//         if(misspelled) {
//             var suggestions = dictionary.getSuggestions('colourr');
//             console.log(suggestions);
//         }
//     }
// });
